import { render, staticRenderFns } from "./batch-actions.vue?vue&type=template&id=28c2e25c&scoped=true&"
import script from "./batch-actions.vue?vue&type=script&lang=ts&"
export * from "./batch-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2e25c",
  null
  
)

export default component.exports